import { Helper } from "../util/helper.js";
import { Commands } from "../util/commandManager.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import { CommandManagerAPI } from "../../commonInterfaces.js";
import React from "react";
import { Config } from "../config/config.js";
export class HTMLEditor extends React.Component<HtmlEditorProps, any>{
    private textAreaRef = null;
    private editorRef: kendo.ui.Editor = null;
    private previousReadOnlyState = false;
    private readOnlyState = false;
    private id: string = "htmlEditor";
    private triggerOnChange = true;

    constructor(props: HtmlEditorProps) {
        super(props)
        this.readOnlyState = this.props.disabled;
        this.previousReadOnlyState = !this.props.disabled;
        if (Helper.hasValue(props.field.triggerOnChange)) {
            this.triggerOnChange = props.field.triggerOnChange;
        }
        this.setEvents();
    }

    private updateReadOnlyState = () => {
        if (this.readOnlyState !== this.previousReadOnlyState) {
            $(this.editorRef.body).attr("contenteditable", this.readOnlyState ? "false" : "true");
            if (this.readOnlyState) {
                const tmpEl = $("<input>");
                tmpEl.attr("readonly", "readonly");
                $("body").append(tmpEl);
                const bgColor = window.getComputedStyle(tmpEl[0]).backgroundColor;
                $(this.editorRef.body).css("background-color", bgColor);
                tmpEl.remove();
            } else {
                $(this.editorRef.body).css("background-color", "");
            }
            this.previousReadOnlyState = this.readOnlyState;
        }
    }

    private setEditorHeight = () => {
        if (!Helper.isNullOrEmpty(this.props.field.staticHeight)) {
            const el = document.querySelector(`#${this.id} iframe`) as HTMLElement;
            el.style.height = this.props.field.staticHeight;
        }
    }

    private getTools = (names: Array<string>) => {
        const result: Array<kendo.ui.EditorTool> = [];

        if (Array.isArray(names)) {
            names.forEach(n => {
                result.push({ name: n });
            });
        }

        return result;
    }

    private setEvents = () => {
        if (!this.readOnlyState) {
            this.props.commandManager.registerExecutor("htmlEditor", (command, data) => {
                if (command === Commands.REFRESH) {
                    try {
                        this.editorRef.refresh();
                        this.updateReadOnlyState();
                        this.setEditorHeight();
                    } catch {

                    }
                }
            });
        }
    }

    componentWillUnmount() {
        if (!this.readOnlyState)
            this.editorRef.destroy();
    }


    componentDidMount() {
        if (!this.readOnlyState) {
            this.buildEditor();
        }
    }

    private buildEditor = () => {
        const tools = this.getTools(['formatting', 'bold', 'italic', 'underline', 'strikethrough', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull',
            'insertUnorderedList', 'insertOrderedList', 'indent', 'createLink', 'foreColor', 'backColor', 'fontName', 'fontSize', 'viewHtml'
        ]);
        //tools.splice(13, 0, {
        //    name: "uploadImage",
        //    exec: this.uploadFile,
        //    template: '<a tabindex="0" role="button" class="k-tool k-group-start k-group-end" unselectable="on"><span class="k-icon k-i-image-insert"></span></a>'
        //});
        this.editorRef = $(this.textAreaRef).kendoEditor({
            encoded: false,
            resizable: true,
            keyup: (e) => {
                if (this.triggerOnChange)
                    this.props.onChange(this.props.field, e.sender.value());
            },
            tools: tools,
            change: (e) => {
                this.props.onChange(this.props.field, e.sender.value());
            },
            stylesheets: [
                `${Config.baseUrl}Content/kendo_html_editor.css`
            ]
        }).data("kendoEditor");
        this.editorRef.value(this.props.value);

        try {
            //Für email sollen anstatt p tags br tags eingefügt werden
            (this.editorRef as any).tools.insertLineBreak.options.shift = false;
            (this.editorRef as any).tools.insertParagraph.options.shift = true;
        } catch {

        }

    }

    componentDidUpdate() {
        this.readOnlyState = this.props.disabled;
        if (!this.readOnlyState) {
            this.editorRef.value(this.props.value);
            this.updateReadOnlyState();
        }
    }

    render() {
        let inner = <></>
        if (this.props.disabled) {
            inner = (
                <>
                    <div dangerouslySetInnerHTML={{ __html: this.props.value }} style={{ borderTop: "#ccc 1px solid", paddingTop: "10px", width: "100%" }}></div>
                </>
            );
        } else {

            inner = (
                <div>
                    <div id={this.id} data-role="emailSenderEditor">
                        <textarea ref={(r) => this.textAreaRef = r} />
                        <input type="text" name={this.props.field.model}
                            required={this.props.required}
                            style={{ display: "none" }}
                            value={Helper.hasValue(this.props.value) && this.props.value !== "" ? "x" : ""}
                            data-label={this.props.field.name}
                            onChange={() => { }}
                        />
                    </div>
                </div>
            );
        }


        return (
            <>

                <div style={{ borderTop: "#ccc 1px solid", paddingTop: "10px", width: "100%", display: this.props.disabled ? "block" : "none" }} className="i_hate_email">
                    <style>
                        {`
                            .i_hate_email h1{font-size:2em;margin:.67em 0}
                            .i_hate_email h2{font-size:1.5em}
                            .i_hate_email h3{font-size:1.16em}
                            .i_hate_email h4{font-size:1em}
                            .i_hate_email h5{font-size:.83em}
                            .i_hate_email h6{font-size:.7em}
                            .i_hate_email p{margin:0 0 1em;}
                            .i_hate_email ul, .i_hate_email ol{padding-left:2.5em}
                            .i_hate_email span{-ms-high-contrast-adjust:none;}
                            .i_hate_email a{color:#00a}
                            .i_hate_email span{white-space: pre-line}
                        `}
                    </style>
                    <div dangerouslySetInnerHTML={{ __html: this.props.value }}></div>
                </div>
                <div id={this.id} data-role="emailSenderEditor" style={{ display: !this.props.disabled ? "block" : "none" }}>
                    <textarea ref={(r) => this.textAreaRef = r} />
                    <input type="text" name={this.props.field.model}
                        required={this.props.required}
                        style={{ display: "none" }}
                        value={Helper.hasValue(this.props.value) && this.props.value !== "" ? "x" : ""}
                        data-label={this.props.field.name}
                        onChange={() => { }}
                    />
                </div>
            </>
        );
    }
};
export interface HtmlEditorProps extends BaseComponentProps {
    field: HtmlEditorField;
    commandManager: CommandManagerAPI;
}

interface HtmlEditorField extends BaseField {
    staticHeight?: string;
    triggerOnChange?: boolean;
}